import { Component, Input, OnInit, EventEmitter, Output, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { translate } from '@jsverse/transloco';
import { DatePipe, TitleCasePipe } from '@angular/common'
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import cronstrue from 'cronstrue';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import moment from 'moment';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { of, switchMap } from 'rxjs';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DisasterRecoveryService } from 'src/app/services/api/disaster-recovery.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Component({
    selector: 'app-tenant-schedule-details',
    templateUrl: './tenant-schedule-details.component.html',
    styleUrls: ['./tenant-schedule-details.component.scss'],
    providers: [TitleCasePipe],
    standalone: false
})
export class TenantScheduleDetailsComponent  implements OnInit {

private destroyRef = inject(DestroyRef);

  breadcrumbItems: BreadcrumbItem[] = [];
  tenantId: any;
  data: any;
  showLoader = false;
  schedulesLoading = true;
  RouterSegments = RouterSegments;
  schedules: any;
  scheduleHistory: any;
  scheduleId: any;
  scheduleStatus: any;
  clearData: boolean;
  status: any;
  selectedStatus = [];
  selectedTriggers: any;
  selectedDetailDate:any = [];
  isSolutionLoading:boolean;
  isCustomImageLoading:boolean;
  drInProgress$: Observable<boolean>;
  isDREnabled$: Observable<boolean>;
  showDRBanner$: Observable<boolean>;

  displayColumns = [
    {
      key: 'updatedAt',
      name: translate('SCHEDULE_DETAILS.DATE_TIME'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: translate('SCHEDULE_DETAILS.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'taskStatus',
      name: translate('SCHEDULE_DETAILS.TASK_STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
     }
  ];
  initialHistory: any;
  dropdownsList: any;
  filteredColumns: any;
  filterStartDate: any;
  filterEndDate: any;
  date: any;
  releaseVersion: any;
  isAWS: boolean;
  packageReference: string;
  targetSolutionVersion: string;

  constructor( public schedulerService: SchedulerService, private activatedRoute: ActivatedRoute, private router: Router, private tenantService: TenantService, private solutionsService :SolutionsService, private instancesService: InstancesService,private disasterRecoveryService:DisasterRecoveryService,
    private toastrService: CustomToastrService, public datePipe: DatePipe, private dialog: MatDialog, public authService: AuthService, private sidenavService: SidenavService, private titleCasePipe: TitleCasePipe, private configurationService: ConfigurationsService) {

      this.drInProgress$ = this.disasterRecoveryService.drInProgress$;
      this.isDREnabled$ = this.disasterRecoveryService.isDREnabled$;
    }

 ngOnInit(): void {
  this.showDRBanner$ = combineLatest([this.drInProgress$, this.isDREnabled$]).pipe(
    map(([drInProgress, isDREnabled]) => drInProgress === true && isDREnabled === true)
  );
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SCHEDULE';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.scheduleId = this.activatedRoute.snapshot.params.scheduleId
    this.breadcrumbItems.push({ label: 'Home', url: [RouterSegments.TENANT, this.tenantId] });
    this.breadcrumbItems.push({label: translate('SCHEDULE_DETAILS.SCHEDULES'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.SCHEDULE]});
    this.scheduleStatus = [
      {value: 'running', label: "Running",selected: false},
      {value: 'completed', label: "Completed",selected: false},
      {value: 'failed', label: "Failed",selected: false},
    ];
    const date = [
      {value: 'Last Run Date', selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.scheduleStatus
      },
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: date
      }
    ];

    if (localStorage.getItem('filteredScheduleDetailStatus')) {
      const statusData = JSON.parse(localStorage.getItem('filteredScheduleDetailStatus'));
      if (statusData) {
        this.selectedStatus = statusData;
        this.status = this.selectedStatus;
        this.dropdownsList[0].options.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredScheduleDetailDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredScheduleDetailDate'));
      if (dateData) {
        this.selectedDetailDate = dateData;
        this.date = this.selectedDetailDate;
        this.dropdownsList[1].options.forEach(element => {
          if(this.selectedDetailDate.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.filterStartDate = localStorage.getItem('filteredScheduleDetailStartDate') ? localStorage.getItem('filteredScheduleDetailStartDate'): '';
    this.filterEndDate = localStorage.getItem('filteredScheduleDetailEndDate') ? localStorage.getItem('filteredScheduleDetailEndDate'): '';

    this.getScheduleDetailsById(this.tenantId, this.scheduleId);
    this.getScheduleHistoryById(this.tenantId, this.scheduleId);
 }

 getScheduleDetailsById(tenantId: string, scheduleId: string): void {
  this.schedulerService.getScheduleDetails(tenantId, scheduleId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(
      (data) => {
        if(this.breadcrumbItems.length > 2) {
          this.breadcrumbItems.pop();
        }
        this.breadcrumbItems.push({ label: this.titleCasePipe.transform(data?.name) });
        data.cronDefinition = (data.frequency !== 'one_time' && data.cronExpression) ? cronstrue.toString(data.cronExpression) : '-';
        let packageReferenceId = data.metadata.packageReferenceId;
        let targetSolutionVersionId = data.metadata.targetSolutionVersionId;
        if(packageReferenceId) this.isCustomImageLoading = true;
        if(targetSolutionVersionId) this.isSolutionLoading = true;
        this.schedules = data;
        const blueprintId = data.metadata.blueprintId;
        if (packageReferenceId || targetSolutionVersionId) {
          let instanceId = data.metadata.instanceId;
          this.instancesService.getInstanceById(instanceId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(instance => {
              const solutionId = instance.solutionId;
              if (packageReferenceId) {
                this.solutionsService.getReferencePackagesById(solutionId, data.metadata.packageReferenceId)
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(referencePackage => {
                    this.packageReference = referencePackage?.name;
                    this.isCustomImageLoading = false;
                  });
              }
              if (targetSolutionVersionId) {
                this.solutionsService.getSolutionVersion(solutionId, targetSolutionVersionId)
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(version => {
                    this.targetSolutionVersion = version?.version;
                    this.isSolutionLoading = false;
                  });
              }
            });
        }
        if(data?.metadata?.configurationId){
         this.configurationService.getConfigurations(blueprintId)
         .pipe(takeUntilDestroyed(this.destroyRef))
         .subscribe(version => {
        const releaseData = version?.find(item => item.id === data?.metadata?.configurationId);
        this.releaseVersion = releaseData?.version;
        });
        }
        this.schedulesLoading = false;
        this.showLoader = false;
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
    );
  }

  getScheduleHistoryById(tenantId: string, scheduleId: string): void {
  this.schedulerService.getScheduleHistory(tenantId, scheduleId)
    .pipe(switchMap(response => {
        if (response.hasNext) {
          const size = response.total
          return this.schedulerService.getScheduleHistory(tenantId, scheduleId, size);
        }
        return of(response);
      }),
      takeUntilDestroyed(this.destroyRef)).subscribe({ 
        next: (result) => {
        const scheduleHistory = result?.data?.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
        this.initialHistory = scheduleHistory;
        this.initialFilterItems();
        this.schedulesLoading = false;
        this.showLoader = false;
      },
      error: (error) => {
      this.initialHistory = [];
      this.scheduleHistory = [];
      this.schedulesLoading = false;
      this.showLoader = false;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
    });
}

  filterColumns(): void {
    if(this.date) {
      this.dropdownsList[0].options.filter((item) => {
        if (item.value === this.date) {
          item.selected = true;
        }
      });
    }
    const data = {
      name: translate('SCHEDULES.SCHEDULE_DETAIL_FILTERS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      scheduleStatusDetailList: this.dropdownsList[0].options,
      scheduleDetailDate: this.dropdownsList[1].options,
      scheduleDetailStartDate: this.dropdownsList[1].options[0]?.selected ? moment(this.filterStartDate) : '',
      scheduleDetailEndDate: this.dropdownsList[1].options[0]?.selected ? moment(this.filterEndDate) : '',
      scheduleDetailColumns: [
        'status',
        'date'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
      if (filteredColumns) {
        this.clearData = true;
        if(filteredColumns[0] !== '') {
          this.status = filteredColumns[0];
        }
        if(filteredColumns[1] !== '') {
          localStorage.removeItem('filteredScheduleDetailDate');
          this.date = filteredColumns[0];
          localStorage.setItem('filteredScheduleDetailDate', JSON.stringify(filteredColumns[0]));
        }
        if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0){
          this.resetScheduleFilter();
        } else {
          this.filterScheduleItems(filteredColumns);
        }
      }
    });
  }

  filterScheduleItems(filteredColumns): void {
    if (filteredColumns) {
      this.scheduleHistory = this.initialHistory;
      this.selectedStatus = [];
      this.selectedTriggers = [];
      this.selectedDetailDate=[];
      if (filteredColumns[0]?.length > 0) {
        this.selectedStatus = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem('filteredScheduleDetailStatus', JSON.stringify(this.selectedStatus));
          this.scheduleHistory = this.scheduleHistory?.filter(item => this.selectedStatus?.includes(item?.status));
        } else {
          localStorage.removeItem('filteredScheduleDetailStatus');
        }
      }
      if (this.dropdownsList[1].options[0].selected && moment(filteredColumns[2].filteredStartDate).isValid() && moment(filteredColumns[2].filteredEndDate).isValid()) {
        this.selectedDetailDate = filteredColumns[1];
        this.filterStartDate = filteredColumns[2].filteredStartDate;
        this.filterEndDate = filteredColumns[2].filteredEndDate;
        localStorage.setItem('filteredScheduleDetailStartDate', this.filterStartDate);
        localStorage.setItem('filteredScheduleDetailEndDate', this.filterEndDate);
        localStorage.setItem('filteredScheduleDetailDate', JSON.stringify(this.selectedDetailDate));
        
        const startDateUTC = moment.utc(moment(this.filterStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day');
        const endDateUTC = moment.utc(moment(this.filterEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day');
        this.scheduleHistory = this.scheduleHistory?.filter(item => {
          const itemDateUTC = moment.utc(item.updatedAt).startOf('day');
          return itemDateUTC.isSameOrAfter(startDateUTC) && itemDateUTC.isSameOrBefore(endDateUTC);
        });

      } else {
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
        localStorage.removeItem('filteredScheduleDetailStartDate');
        localStorage.removeItem('filteredScheduleDetailEndDate');
      }
    }
  }

  initialFilterItems() {
    this.scheduleHistory = this.initialHistory;
    if (this.selectedStatus?.length > 0) {
      this.scheduleHistory = this.scheduleHistory?.filter(item => this.selectedStatus?.includes(item?.status));
    }
    if (this.selectedDetailDate?.length > 0 && this.dropdownsList[1].options[0].selected && this.filterStartDate && this.filterEndDate) {
      const startDateUTC = moment.utc(moment(this.filterStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day');
      const endDateUTC = moment.utc(moment(this.filterEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day');
      this.scheduleHistory = this.scheduleHistory?.filter(item => {
          const itemDateUTC = moment.utc(item.updatedAt).startOf('day');
          return itemDateUTC.isSameOrAfter(startDateUTC) && itemDateUTC.isSameOrBefore(endDateUTC);
      });
    }
  }

  getUTCTimestamp(date): any {
    return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
  }

  getStatusLabel(status): void {
    return this.scheduleStatus.find(item=> item.value === status).label;
  }

  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredScheduleDetailStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredScheduleDetailStatus', JSON.stringify(this.selectedStatus));
      this.filterScheduleItems(this.filteredColumns);
    }
  }

  cancelScheduleDateFilter() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.dropdownsList[1].options[0].selected = false;
    this.date?.forEach(element => {
      if(element.includes(this.dropdownsList[0].options[0].value)) {
        this.date.pop(element);
      }
    });

    localStorage.removeItem('filteredScheduleDetailStartDate');
    localStorage.removeItem('filteredScheduleDetailEndDate');
    localStorage.removeItem('filteredScheduleDetailDate');
    this.filterScheduleItems(this.filteredColumns);
  }

  resetScheduleFilter(): void {
    this.selectedStatus = [];
    this.selectedDetailDate=[];
    this.dropdownsList[0].options.filter((item) => {item.selected = false});
    this.dropdownsList[1].options.filter((item) => {item.selected = false});
    this.status = undefined;
    this.date = undefined;
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.scheduleHistory = this.initialHistory;
    localStorage.removeItem('filteredScheduleDetailStatus');
    localStorage.removeItem('filteredScheduleDetailDate');
    localStorage.removeItem('filteredScheduleDetailStartDate');
    localStorage.removeItem('filteredScheduleDetailEndDate');
  }

  /**
  * Navigates to the instance details page using the instanceId and blueprintId from metadata.
  */
  navigateToInstance(instance) {
  this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.schedules.metadata?.blueprintId, RouterSegments.ENVIRONMENT, this.schedules.metadata?.instanceId])
  }

  /**
  * Navigates to the blueprint page using the blueprintId from metadata.
  */
  navigateToBlueprint(id) {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.schedules.metadata?.blueprintId ])
  }
  onDisableSchedule(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULES.DISABLE_TITLE'),
        message: translate('SCHEDULES.DISABLE_MESSAGE'),
        scheduleName: this.schedules.name.includes('-') ? this.schedules.name.split('-')[0].trim() : this.schedules.name,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        this.schedulerService.scheduleDisable(this.tenantId, this.schedules.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            this.getScheduleDetailsById(this.tenantId, this.scheduleId);
            setTimeout(() => {
              const title = translate('TENANT_LAYOUT.MENU.SCHEDULE');
              const message = translate('SCHEDULES.DISABLED_SUCCESS_MSG');
              this.toastrService.successMessage(message, title);
            }, 500);
          }, (error) => {
            const description = error?.message 
            || error?.error?.message 
            || error?.errmsg 
            || translate('SERVICE.INTERNAL_SERVER_ERROR');
            setTimeout(() => {
              this.openErrorDialog(error);
            }, 500);
          })
      }
  })
    
  }

  onEnableSchedule(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULES.ENABLE_TITLE'),
        message: translate('SCHEDULES.ENABLE_MESSAGE'),
        scheduleName: this.schedules.name.includes('-') ? this.schedules.name.split('-')[0].trim() : this.schedules.name,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
      this.schedulerService.scheduleEnable(this.tenantId, this.schedules.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          this.getScheduleDetailsById(this.tenantId, this.scheduleId);
            setTimeout(() => {
              const title = translate('TENANT_LAYOUT.MENU.SCHEDULE');
              const message = translate('SCHEDULES.ENABLED_SUCCESS_MSG');
              this.toastrService.successMessage(message, title);
            }, 500);
        }, (error) => {
          const description = error?.message 
          || error?.error?.message 
          || error?.errmsg 
          || translate('SERVICE.INTERNAL_SERVER_ERROR');
          setTimeout(() => {
            this.openErrorDialog(error);
          }, 500);
        })
    }
})
  }

  // Error block
  openErrorDialog(data): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('SCHEDULE_DETAILS.SCHEDULE_VALIDATION_ERROR'),
        descriptionError: data
      }
    });
  }
}
